/* globals alert, confirm, console, module, require */
/* jshint esversion:6, globalstrict:true */
'use strict';

const async = require('async'),
    jQuery = require('jquery'),
    Marionette = require('backbone.marionette'),
    _ = require('lodash'),
    // models & collections
    user = require('../models/user'),
    Contacts = require('../collections/contacts'),
    // views
    ContactsList = require('./contactsList'), // @acavan!
    ModalDialog = require('./modalDialog'),
    // utilities
    AddressAutocomplete = require('../utilities/addressAutocomplete'),
    enumerations = require('../utilities/enumerations'),
    helpers = require('../utilities/handlebars').helpers,
    templates = require('../utilities/handlebars').templates,
    EOL = null;

module.exports = Marionette.View.extend({
    attributes: {
        class: 'organization-details'
    },
    childViewEvents: {
        'edit:end': function (options) {this.trigger('edit:end', options);},
        'edit:inProgress': function (options) {this.trigger('edit:inProgress', options);},
        'edit:start': function (options) {this.trigger('edit:start', options);}
    },
    events: {
        'click button': 'onClickButton',
        'change @ui.address1': 'onChangeAddress',
        'change @ui.address2': 'onChangeAddress',
        'change @ui.city':     'onChangeAddress',
        'change @ui.state':    'onChangeAddress',
        'change @ui.zip':      'onChangeAddress',
        'change select':       'onChangeSelect',
        'input input':         'onChangeInput'
    },
    refreshCoordinates: false,
    regions: {
        contactsList: {el: 'div[name=contactsList]', replaceElement: true}
    },
    template: templates.organizationDetails,
    ui: {
        contactForm: 'form[name=contact]',
        summaryForm: 'form[name=summary]',
        //
        address1: 'input[name=address1]',
        address2: 'input[name=address2]',
        city: 'input[name=city]',
        countyId: 'input[name=countyId]',
        state: 'input[name=state]',
        zip: 'input[name=zip]',
        latitude: 'input[name=latitude]',
        longitude: 'input[name=longitude]',
        location: 'input[name=location]',
        locationComment: 'small[name=locationComment]',
        // contact fields only present if create...
        email: 'form[name=contact] input[name=email]',
        first: 'form[name=contact] input[name=first]',
        last: 'form[name=contact] input[name=last]',
        title: 'form[name=contact] input[name=title]',
        phoneNumbersOnly: 'form[name=contact] input[name=phoneNumbersOnly]'
    },
    //
    initialize: function () {
        this.create = !this.model;
        if (!this.create) {
            this.templateContext = {
                buttonEdit: 'buttonEditOrganizationDetails',
                deleteable: user.hasCapability('administrator')
            };
            this.listenTo(this.model, 'change', _.bind(function () {
                this.render();
            }, this));
        } else {
            this.templateContext = {
                name: 'New Organization',
                create: true,
                organizationRoleTypeId: enumerations.codeValues.organizationRoleTypePrimaryContact,
                organizationStatusTypeId: enumerations.codeValues.organizationStatusTypeActive
            };
            this.contacts = new Contacts([], {type: 'organization', id: this.organizationId, full: true});
            this.listenTo(this.contacts, 'sync', _.bind(function (event) {
                const a = ['<option value="-1" selected>New contact</option>'];
                _.each(this.contacts.models, function (model) {
                    a.push('<option value="' + model.id + '">' + model.id + '</option>');
                });
                jQuery('select[name=existingContactId]', this.$el).html(a.join('\n'));
                // console.log(console.log(a.join('\n')));
            }, this));
        }
    },
    onChangeAddress: function () {
        this.refreshCoordinates = true;
    },
    onChangeInput: function () {
        this.onEditInProgress();
        return false;
    },
    onChangeSelect: function (event) {
        let existingContact,
            contact;
        // should only be one select but out of an abundance of caution...
        switch (event.currentTarget.name) {
            case 'existingContactId':
                existingContact = event.currentTarget.value !== '-1';
                if (existingContact) {
                    contact = this.contacts.get(event.currentTarget.value);
                }
                this.ui.email.prop('disabled', existingContact).val(existingContact ? contact.id : '');
                _.each(['first', 'last', 'title', 'phoneNumbersOnly'], _.bind(function (field) {
                    let value = '';
                    if (existingContact) {
                        switch (field) {
                            case 'phoneNumbersOnly':
                                value = helpers.telephone(contact.get(field));
                                break;
                            default:
                                value = contact.get(field);
                                break;
                        }
                    }
                    this.ui[field].prop('disabled', existingContact).val(value);
                }, this));
                break;
            default:
                break;
        }
        this.onEditInProgress();
        // console.log('organizationDetails.onChangeSelect');
    },
    onClickButton: function (event) {
        let trigger = true;
        const action = event.currentTarget.dataset.action,
            section = event.currentTarget.dataset.section,
            mode = function (mode, section) {
                jQuery('div[name=display], button[name=edit]', section).toggleClass('hidden', mode === 'edit');
                jQuery('div[name=edit], button[name=save], button[name=delete], button[name=cancel]', section).toggleClass('hidden', mode === 'display');
            },
            processSection = _.bind(function (action, callback) {
                const concatenateAddress = _.bind(function () {
                        const ui = this.ui;
                        let s = '',
                            value;
                        _.each(['address1', 'address2', 'city', 'state', 'zip'], function (key) {
                            value = ui[key].val();
                            s += value ? value + ' ' : '';
                        });
                        return s;
                    }, this);
                let serializedArray;
                if (!this.currentSection) {
                    return;
                }
                serializedArray = this.ui[this.currentSection + 'Form'].serializeArray();
                if (JSON.stringify(this.priorSerializedArray) === JSON.stringify(serializedArray)) {
                    // presumably results from serializeArray are always the same if form contents haven't changed
                    // if that turns out to not be the case then we can switch to lodash.isEqual (and definitely not split and sort stringified results...)
                    // for 1000 iterations - JSON.stringify:8.912ms, lodash.isEqual:30.450ms,  JSON.stringify.split('').sort():140.744ms
                    this.render();
                    return;
                }
                async.waterfall([
                    _.bind(function (callback) {
                        if (this.refreshCoordinates) {
                            this.addressAutocomplete.resolveLocation(concatenateAddress(), callback);
                        } else {
                            callback(null, null);
                        }
                    }, this),
                    _.bind(function (results, callback) {
                        const ui = this.ui;
                        if (results) {
                            _.each(results, function (value, key) {
                                if (ui[key]) {
                                    ui[key].val(value);
                                }
                            });
                            serializedArray = this.ui[this.currentSection + 'Form'].serializeArray();
                        }
                        if (!this.create) {
                            this.model.update(serializedArray, true, callback);
                        } else {
                            this.collection.create(serializedArray, this.ui.contactForm.serializeArray());
                        }
                        this.currentSection = null;
                    }, this)
                ], _.bind(function (error, results) {
                    callback(error, null);
                }, this));
            }, this);
        switch (action) {
            case 'cancel':
                if (!this.create) {
                    mode('display', jQuery(event.currentTarget).closest('div[name=' + section + ']'));
                    this.editInProgress = false;
                    this.render();
                } else {
                    this.destroy();
                }
                break;
            case 'close':
                if (!this.create) {
                    if (JSON.stringify(this.priorSerializedArray) !== JSON.stringify(this.ui[this.currentSection + 'Form'].serializeArray())) {
                        if (confirm('Changes have not been saved.\nClick OK to save before continuing.\nClick Cancel to continue without saving.')) {
                            processSection('save', _.bind(function (error) {
                                if (error) {
                                    alert(error);
                                    this.render();
                                }
                            }, this));
                        }
                    } else {
                        this.destroy();
                    }
                } else {
                    this.destroy();
                }
                break;
            case 'delete':
                this.modalDialog = new ModalDialog({template: templates.delete, templateContext: {type: 'organizationLabel', name: this.model.attributes.name}});
                this.modalDialog.on('modalDialog:delete', _.bind(function (o) {
                    // console.log('organizationDetails.onClickButton.delete');
                    this.model.destroy();
                    this.destroy();
                }, this));
                break;
            case 'edit':
                this.currentSection = section;
                this.priorSerializedArray = this.ui[this.currentSection + 'Form'].serializeArray();
                mode('edit', jQuery(event.currentTarget).closest('div[name=' + section + ']'));
                this.trigger('edit:start');
                trigger = false;
                break;
            case 'save':
                // if (this.ui.summaryForm.valid() && (!this.ui.contactForm[0] || this.ui.contactForm.valid())) {
                if (this.ui.summaryForm[0].checkValidity() && (!this.ui.contactForm[0] || this.ui.contactForm[0].checkValidity())) {
                    processSection('save', _.bind(function (error) {
                        if (error) {
                            alert(error);
                        } else if (this.create) {
                            this.destroy();
                        }
                        this.editInProgress = false;
                    }, this));
                } else {
                    this.ui.summaryForm.toggleClass('was-validated', true);
                    this.ui.contactForm.toggleClass('was-validated', true);
                    trigger = false;
                }
                break;
            default:
                console.log('organizationDetails.onClickButton - action:%s', action);
                break;
        }
        if (trigger) {
            this.trigger('edit:end');
        }
        return false;
    },
    onEditInProgress: function () {
        if (!this.editInProgress) {
            this.$el.find('button[data-action=save]').attr('disabled', false);
            this.editInProgress = true;
        }
    },
    onRender: function () {
        const ui = this.ui,
            onLocation = _.bind(function (location) {
                if (!location.error) {
                    this.refreshCoordinates = false;
                    _.each(location, function (value, key) {
                        if (ui[key]) {
                            ui[key].val(value);
                        }
                    });
                    ui.locationComment.text('');
                } else {
                    ui.locationComment.text(location.error);
                }
            }, this);
        if (!this.create) {
            this.showChildView('contactsList', new ContactsList({type: 'organization', id: this.options.organizationId, hasAdminAccess: this.model.get('hasAdminAccess'), title: 'contactsTitle', display: 'contactTitle'}));
        } else {
            // if here the summary form must be showing
            this.currentSection = 'summary';
            jQuery('select[name=existingContactId]', this.$el).html('<option value="-1" selected>New contact</option>');
        }
        this.addressAutocomplete = new AddressAutocomplete(ui.location[0], onLocation);
        return this;
    }
});
